
const getters = {
  getFlights: state => state.flights,
  getFlight: state => flightIndex => state.flights[flightIndex].aviatickets,
  getFlightForm: state => flightIndex => state.flights[flightIndex].form,
  getFlightQuotasDates: state => flightIndex => state.flights[flightIndex].quotasDates,
  // eslint-disable-next-line
  getFlightFormForSearch: (state, getters) => flightIndex => {
    const {
      cityFrom,
      cityTo,
      startDate,
      endDate,
      flightClass,
      transfersCount,
      perPage,
      isRepeatedSearch
    } = getters.getFlightForm(flightIndex)

    const {
      adults,
      numbrOfChildren: children,
      numberOfInfants: infants
    } = getters.getNumberOfTourists

    const currency = getters.getCartPrice.currency

    return {
      routes: [
        {
          fromLocationId: cityFrom.slug,
          fromLocationType: cityFrom.code,
          toLocationId: cityTo.slug,
          toLocationType: cityTo.code,
          date: startDate
        },
        {
          fromLocationId: cityTo.slug,
          fromLocationType: cityFrom.code,
          toLocationId: cityFrom.slug,
          toLocationType: cityTo.code,
          date: endDate
        }
      ],
      class: flightClass,
      adults,
      children,
      infants,
      transfersCount,
      currency,
      page: 1,
      perPage,
      isRepeatedSearch
    }
  },
  getFlightPagination: state => flightIndex => state.flights[flightIndex].pagination,
  getFlightIsCollectionLoading: state => flightIndex => (
    state.flights[flightIndex].isCollectionLoading
  ),
  getFlightTarrifs: state => ({ flightIndex, aviaticketId }) => (
    state.flights[flightIndex].aviatickets.collection
      .find(aviaticket => aviaticket.id === aviaticketId).tarrifs
  ),
  getFlightRules: state => ({ flightIndex, aviaticketId }) => (
    state.flights[flightIndex].aviatickets.collection
      .find(aviaticket => aviaticket.id === aviaticketId).rules
  )
}

export default getters